import * as React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '@teivor/shared-utils/api';

import { Button, FormField, Input } from '../../lib/ui';

export function PasswordResetRequestPage() {
  const { t } = useTranslation();
  const [email, setEmail] = React.useState('');
  const [sent, setSent] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      // Always neutral: the API never reveals whether the email exists.
      await api.iam.resetRequest({ email }).catch(() => undefined);
      setSent(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <h1 className="mb-1 text-2xl font-semibold">{t('auth.password_reset')}</h1>
      <p className="mb-6 text-sm text-[var(--color-fg-secondary)]">{t('auth.send_reset_link')}</p>
      {sent ? (
        <div role="status" className="mb-4 rounded-[var(--radius-md)] border border-[var(--color-border)] bg-[var(--color-surface-2)] p-3 text-sm">
          {t('auth.reset_email_sent_generic', 'If an account exists for that email, a reset link has been sent.')}
        </div>
      ) : (
        <form onSubmit={submit} className="flex flex-col gap-4">
          <FormField label={t('auth.email')} htmlFor="email" required>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" required />
          </FormField>
          <Button type="submit" fullWidth loading={submitting}>{t('auth.send_reset_link')}</Button>
        </form>
      )}
      <p className="mt-6 text-center text-sm">
        <Link to="/login" className="inline-flex min-h-11 items-center text-[var(--color-accent)] hover:underline">
          {t('common.back')} &rarr; {t('auth.sign_in')}
        </Link>
      </p>
    </div>
  );
}
